import React from 'react'
import { Skeleton, Typography } from '@mui/material'

import BodyHeader from '../molecules/BodyHeader'
import Downloads from '../molecules/Downloads'
import Zone from '../organisms/Zone'

import useActivityReport from '../../hooks/useActivityReport'
import Button from '../atoms/Button'
import { APP_BASE_URL, PROJECTS_URL } from '../../constants'

const ActivityReport = () => {
	const { isLoading, title, content } = useActivityReport()

	return (
		<>
			{(isLoading && <Skeleton />) || <BodyHeader title={title}>{content}</BodyHeader>}
			<Zone color="white">
				<Downloads />
			</Zone>
			<Zone color="ivory">
				<Typography sx={{ color: 'text.primary', fontSize: 32, fontWeight: 700, mb: 2 }}>
					Découvrez les projets de la Collecterie
				</Typography>
				<Typography sx={{ color: 'text.primary' }}>
					À La Collecterie nous avons toujours plein de projets en cours : événements, partenariats
					avec d’autres associations, projets de structure, agrandissements, rénovation...
				</Typography>

				<Button
					bgColor="green"
					color="white"
					label="Voir les projets"
					mt={4}
					href={`${APP_BASE_URL}${PROJECTS_URL}`}
				/>
			</Zone>
		</>
	)
}

export default ActivityReport
